import { get } from './request'
import { getItemSync, setItemSync } from '../cache'
import { getUin } from '../user';

/**
 * 加载vtools文件
 * @param url
 * @param expire
 * @returns {*}
 */
export function loadVtools(url, expire = 0) {
    const cacheKey = getUin() + url;
    if (expire) {
        const cacheResult = getItemSync(cacheKey);
        if (cacheResult) return Promise.resolve(cacheResult);
    }

    const gap = url.indexOf('?') > -1 ? '&' : '?'
    let p = get(url + gap + 'v=' + (new Date()));

    p = p.then(res => {
        return res.data;
    });

    p = p.then(data => {
        if (expire) {
            setItemSync(cacheKey, data, expire);
        }
        return data;
    });
    return p;
}